import { parseJwt } from "../AuthVerify";

// If there is a logged in user with accessToken (JWT), return HTTP Authorization header. Otherwise, return an empty object.
export default function authHeader() {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user && user.accessToken) {
      const decodedJwt = parseJwt(user.accessToken);
      if (decodedJwt.exp * 1000 < Date.now()) {
        localStorage.removeItem("user");
        window.location.reload();
      }
    }
  
    if (user && user.accessToken) {
      return { Authorization: 'Bearer ' + user.accessToken };
    } else {
      return {};
    }
  }
  
